var _a;
import { CURRENCY_ID } from '../constants';
export var DEFAULT_SEPARATOR_PATTERN = [3];
var COMMA = ',';
var PERIOD = '.';
var SPACE = ' ';
export var SYMBOL_POSITION = {
    FRONT: 'FRONT',
    BACK: 'BACK',
    FRONT_AND_BACK: 'FRONT_AND_BACK',
};
var DEFAULT_CURRENCY_CONF = {
    symbol: '$',
    precision: 2,
    separator: COMMA,
    separatorPattern: DEFAULT_SEPARATOR_PATTERN,
    decimalPoint: PERIOD,
    spaceBetweenSymbol: false,
    symbolPosition: SYMBOL_POSITION.FRONT,
};
var CURRENCY = (_a = {
        default: DEFAULT_CURRENCY_CONF
    },
    _a[CURRENCY_ID.SGD] = DEFAULT_CURRENCY_CONF,
    _a[CURRENCY_ID.IDR] = {
        symbol: 'Rp',
        precision: 0,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.MYR] = {
        symbol: 'RM',
        precision: 2,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.PHP] = {
        symbol: '₱',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.TWD] = {
        symbol: '$',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.THB] = {
        symbol: '฿',
        maxPrecision: 2,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.VND] = {
        symbol: '₫',
        precision: 0,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.IRR] = {
        symbol: 'تومان',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.MMK] = {
        symbol: 'Ks',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.HKD] = DEFAULT_CURRENCY_CONF,
    _a[CURRENCY_ID.BRL] = {
        symbol: 'R$',
        precision: 2,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.CNY] = {
        symbol: '￥',
        precision: 2,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.MXN] = {
        symbol: ['$', 'MXN'],
        spaceBetweenSymbol: [false, true],
        symbolPosition: SYMBOL_POSITION.FRONT_AND_BACK,
        precision: 2,
        separator: COMMA,
        decimalPoint: PERIOD,
    },
    _a[CURRENCY_ID.COP] = {
        symbol: 'COP',
        precision: 0,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.CLP] = {
        symbol: 'CLP',
        precision: 0,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.ARS] = {
        symbol: '$',
        precision: 2,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.PLN] = {
        symbol: 'zł',
        symbolPosition: SYMBOL_POSITION.BACK,
        precision: 2,
        separator: SPACE,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
    },
    _a[CURRENCY_ID.EUR] = {
        symbol: '€',
        symbolPosition: SYMBOL_POSITION.BACK,
        precision: 2,
        separator: PERIOD,
        decimalPoint: COMMA,
        spaceBetweenSymbol: false,
    },
    _a[CURRENCY_ID.INR] = {
        symbol: '₹',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        separatorPattern: [3, 2, 2],
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.USD] = {
        symbol: 'USD',
        precision: 2,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a[CURRENCY_ID.KRW] = {
        symbol: 'KRW',
        precision: 0,
        separator: COMMA,
        decimalPoint: PERIOD,
        spaceBetweenSymbol: false,
        symbolPosition: SYMBOL_POSITION.FRONT,
    },
    _a);
export default CURRENCY;
